import { useCallback, useEffect, useMemo, useState } from "react";
import { useTrendingNichesStore } from "../store/trendingNichesStore";
import { apiNiches } from "../services";
import { INiche , IErrorData } from "../api/services/types";
import { convertException } from "@/common/utils/convertException";

const TRENDING_NICHES_VARIANT = "search";

export const useTrendingNiches = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<IErrorData | null>(null);
  const [data, setData] = useState<{ niches: INiche[] } | null>(null);

  const setTrendingNiches = useTrendingNichesStore((state) => state.setTrendingNiches);
  const trendingNiches = useTrendingNichesStore((state) => state.trendingNiches);

  const fetchTrendingNiches = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await apiNiches.getTrendingNiches(TRENDING_NICHES_VARIANT);
      setData(result);
    } catch (err) {
      setError(convertException(err));
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await fetchTrendingNiches();
    })();
  }, [fetchTrendingNiches]);

  useEffect(() => {
    if (!error && data && data.niches) {
      setTrendingNiches(data.niches);
    }
  }, [error, data, setTrendingNiches]);

  const niches = useMemo(() =>
    trendingNiches.map((el: INiche) => ({
      id: el.id,
      name: el.name,
      image: el.thumbnail,
      subscribers: el.subscribers,
    })), [trendingNiches]);

  return {
    trendingNiches: niches,
    error,
    isLoading
  };
};
